<template>
  <CFooter class="no-print">
    <div>
      <a href="https://www.prismafive.com.br/prismasync/" target="_blank">
        PrismaSync
      </a>
      <span class="ml-1">&copy; 2024 Versão 4.9.1</span>
    </div>
    <div class="ml-auto">
      <span class="mr-1">{{ $t("sectionFooter.footerDuvidas") }}</span>
      <a href="https://suporte.prismafive.com.br/" target="_blank">{{
        $t("sectionFooter.footerSuporte")
      }}</a>
    </div>
    <div class="ml-auto">
      <span class="mr-1">{{ $t("sectionFooter.footerDesenvolvido") }}</span>
      <a href="https://www.prismafive.com.br" target="_blank">PrismaFive</a>
    </div>
  </CFooter>
</template>

<script>
export default {
  name: "TheFooter",
  data() {
    return {
      locale: this.$i18n.locale,
      
    };
  },
  watch: {
    locale(val) {
      this.$i18n.locale = val;
    }
  },
};
</script>
